import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

// Wrap your app once with <HelmetProvider> in App.js
// Use <SEO /> inside pages to set meta tags per route

export const SEO = ({
  title = "Renobuild Group — Home Extensions in London",
  description = "General building firm specialising in home extensions across London & the Home Counties. Book a free home visit.",
  canonical,
  image,
  schema = []
}) => {
  const computedCanonical = (() => {
    try {
      if (canonical) return canonical;
      if (typeof window !== "undefined") {
        return window.location.origin + window.location.pathname;
      }
    } catch (_) {}
    return undefined;
  })();

  const LOGO_URL = "https://customer-assets.emergentagent.com/job_spacegrow/artifacts/7nerl75q_RB%20Colour%20RGB%20Renobuild%20Group%20logo.png";
  const ogImage = image || LOGO_URL;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index,follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#ff6a00" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {computedCanonical && <meta property="og:url" content={computedCanonical} />}
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Canonical */}
      {computedCanonical && <link rel="canonical" href={computedCanonical} />}

      {/* Hreflang */}
      {computedCanonical && <link rel="alternate" hrefLang="en-gb" href={computedCanonical} />}

      {/* Icons (using logo as fallback) */}
      <link rel="icon" href={LOGO_URL} />
      <link rel="apple-touch-icon" href={LOGO_URL} />

      {/* Structured Data */}
      {Array.isArray(schema) ? (
        schema.map((s, i) => (
          <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
        ))
      ) : schema ? (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      ) : null}
    </Helmet>
  );
};
